import { Link } from "react-router";
import styles from "./Logo.module.css";

export function Logo({ gift = false, large = false }: { gift?: boolean; large?: boolean }) {
  const className = [styles.logo, gift ? styles.gift : "", large ? styles.large : ""].join(" ");
  return (
    <Link to="/" className={className} aria-label="Селфигурка, на главную">
      <span className={styles.start} aria-hidden="true">
        сел
      </span>
      <span className={styles.middle} aria-hidden="true">
        фи
      </span>
      <span className={styles.end} aria-hidden="true">
        гурка
      </span>
    </Link>
  );
}
